
import React, { useEffect, useState } from "react"
import { md, pki } from "node-forge"
import classNames from "classnames"

const KeyUpload = ({onKeyUpload}) => {
  const [pem, setPem] = useState(null)
  const [password, setPassword] = useState("")
  const [uploaded, setUploaded] = useState(false)
  
  if (!onKeyUpload) {
      onKeyUpload = (key, password) => console.log(key)
  }

  const handleSelect = (e) => {
    const file = e.currentTarget.files[0]
    file.text().then(pem => setPem(pem))
  }

  const upload = () => {
      let privateKey
      if (password) {
          privateKey = pki.decryptRsaPrivateKey(pem, password)
      } else {
          privateKey = pki.privateKeyFromPem(pem)
      }
      onKeyUpload(privateKey, password)
      setUploaded(true)
  }

  return (<form onSubmit={e => {e.preventDefault(); upload()}}>
      <div className="form-group">
        <label htmlFor="file-upload">
            Private key <small className="text-muted">(PEM format)</small><br />
            <small className="text-success">Your private key will not leave your local browser.</small>
        </label>
        <input className="form-control-file" id="file-upload" type="file"
               onChange={e => handleSelect(e)} />
      </div>
      <div className="form-group">
        <label htmlFor="password">Password <small className="text-muted">(optional, to decrypt key)</small></label>
        <input className="form-control" id="password" type="password"
                value={password}
                onChange={e => setPassword(e.target.value)} />
      </div>
      <button type="button"
              className={classNames("btn",
                                    {"btn-primary": !uploaded},
                                    {"btn-outline-primary": uploaded})}
              disabled={!pem}
              onClick={() => upload()}>
        Import
      </button>
  </form>)
}

export default KeyUpload
